import {
  Modal,
  ModalContent,
  type ModalHook,
  ModalSize,
  useControlledModalState,
} from '@leland-dev/leland-ui-library';
import { type FC } from 'react';

import { BootcampCohortList } from './BootcampCohortList';
import { BootcampEnrollCohortItem } from './BootcampEnrollCohortItem';
import { type SelectCohortModalCohortFragment } from './__generated-gql-types__/SelectCohortModal.generated';

interface SelectCohortModalHookProps {
  cohorts: SelectCohortModalCohortFragment[];
  maximumAttendees: Possible<number>;
}

interface SelectCohortModalProps extends SelectCohortModalHookProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const SelectCohortModalContent: FC<SelectCohortModalProps> = ({
  open,
  setOpen,
  cohorts,
  maximumAttendees,
}) => {
  return (
    <Modal open={open} onOpenChange={setOpen}>
      <ModalContent header="Select a cohort" size={ModalSize.MEDIUM}>
        <div className="p-4">
          <BootcampCohortList
            cohorts={cohorts}
            renderCohort={(cohort) => (
              <BootcampEnrollCohortItem
                key={cohort.id}
                cohort={cohort}
                maximumAttendees={maximumAttendees}
              />
            )}
          />
        </div>
      </ModalContent>
    </Modal>
  );
};

export const useSelectCohortModal: ModalHook<
  SelectCohortModalHookProps
> = () => {
  const [open, setOpen] = useControlledModalState();
  const SelectCohortModal: FC<SelectCohortModalHookProps> = (props) => {
    return open ? (
      <SelectCohortModalContent {...props} open={open} setOpen={setOpen} />
    ) : null;
  };
  return { open, setOpen, Modal: SelectCohortModal };
};
